import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toDecimal'
})
export class ConvertToDecimal implements PipeTransform {
  transform(input: string, symbol: number): string {
    let transformed = '';
    if (input !== undefined) {
      const value = parseFloat(input.toString().replace(/,/g, ''));
      transformed = value.toFixed(symbol);
    }
    return transformed;
  }
}
